module.exports = __webpack_public_path__ + "assets/img/role_smoll-30b1073e.gif";